import { getStartAndEndDateForQuickOption } from "utils/dateUtils";
import { makeCancellableAPIRequest } from "./index";

const AlertsAPI = {
    getAll(params, data) {
        modifyFilters(data);
        return makeCancellableAPIRequest(
            "POST",
            "/api/alerts",
            {
                params,
                data
            }
        )
    },
    getFilters() {
        return makeCancellableAPIRequest(
            "GET",
            "api/alerts/alert-filters"
        )
    },
    getUnreadAlertCount(params) {
        modifyFilters(params);
        return makeCancellableAPIRequest(
            "GET",
            "/api/alerts/alert-notification-stats",
            {
                params: {
                    ...params,
                    state: 'UNREAD'
                },
            }
        )
    },
    getAllConfigs(queryParams = {}) {
        queryParams = {...queryParams, isWatcherRequired: true}
        return makeCancellableAPIRequest(
            "GET",
            "/api/alert-configs",
            {
                params: queryParams
            }
        )
    },
    getAllGlobalConfigs(queryParams = {}) {
        return makeCancellableAPIRequest(
            "GET",
            "/api/alert-configs/global",
            {
                params: queryParams
            }
        )
    },
    markUnread(id) {
        return makeCancellableAPIRequest(
            "PUT",
            `/api/alerts/update`,
            {
                data: {
                    state: 'UNREAD',
                    id: [id]
                }
            }
        );
    },
    updateMarkAsRead(id) {
        return makeCancellableAPIRequest(
            "PUT",
            `/api/alerts/update`,
            {
                data: {
                    state: 'READ',
                    id: id
                }
            }
        );
    },

    createConfig(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/alert-configs",
            {
                data
            }
        )
    },
    updateConfig(data) {
        return makeCancellableAPIRequest(
            "PUT",
            `/api/alert-configs/global/${data.id}`, 
            {
                data
            }
        )
    },
    createTicket(id,data) {
        return makeCancellableAPIRequest(
            "POST",
            `api/alerts/${id}/ticket`,
            {
                data
            }
        )
    },
    update(id, data) {
        return makeCancellableAPIRequest(
            "PUT",
            `api/alerts/${id}`,
            {
                data
            }
        )
    },
    get(id) {
        return makeCancellableAPIRequest(
            "GET",
            `api/alerts/${id}`,
        )
    },
    getAlertNotificationSource(toolName){
        return makeCancellableAPIRequest(
            "GET",
            "/api/alert-configs/eventwhen/INTEGRATION",
            {
                params: {toolName}
            }
        )      
    },
    createAlertNotification(data){
        return makeCancellableAPIRequest(
            "POST",
            "api/alert-configs",
            {
                data
            }
        )  
    },
    updateAlertNotification(data, id){
        return makeCancellableAPIRequest(
            "PUT",
            `api/alert-configs/${id}`,
            {
                data
            }
        )  
    },
    deleteAlertNotification(id){
        return makeCancellableAPIRequest(
            "DELETE",
            "api/alert-configs/",
            {
                params: {id}
            }
        )  
    },
    getAlertNotification(toolName, pageSize){
        const params = {source: "INTEGRATION", toolName, isWatcherRequired: true};
        if (pageSize) {
            params.size = pageSize;
        }
        return makeCancellableAPIRequest(
            "GET",
            "api/alert-configs",
            {
                params
            }
        )  
    },
    getAlertNotificationConfigStatus(){
        return makeCancellableAPIRequest(
            "GET",
            "api/alert-configs/status/INTEGRATION"
        )  
    },
    postToolScanFrequency(data) {
        return makeCancellableAPIRequest(
            "POST",
            "user/tools/scheduler",
            {
                data
            }
        )
    },
    updateToolScanFrequency(data, id) {
        return makeCancellableAPIRequest(
            "PUT",
            `user/tools/scheduler/${id}`,
            {
                data
            }
        )
    },
    getToolScanFrequency(toolName) {
        return makeCancellableAPIRequest(
            "GET",
            `user/tools/scheduler/default/${toolName}`
        )
    }, 
    getproductSubproductToolConfig(toolName) {
        return makeCancellableAPIRequest(
            "GET",
            `user/tools/scheduler/${toolName}`
        )
    }, 
    deleteProductSubproductToolConfig(id) {
        return makeCancellableAPIRequest(
            "DELETE",
            `/user/tools/scheduler/${id}`
        )
    },
    updateAllFilteredAlerts(params){
        return makeCancellableAPIRequest(
            "PUT",
            `/api/alerts/`,
            {
                params
            }
        )
    },
}

export const NotificationsAPI = {
    getAll() {
        return makeCancellableAPIRequest(
            "GET",
            "/api/alert-notifications"
        )
    },
    create(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/api/alert-notifications",
            {
                data
            }
        )
    }
}

export default AlertsAPI;

const modifyFilters = (params) => {
    if(params && params.createdAt && params.createdAt.length === 1){
        params.createdAt = getStartAndEndDateForQuickOption({ label: params.createdAt[0], utcString: true });
    }
}
